import { VerseSyllable } from "./VerseText";

export const joinSyllables = (
  syls: VerseSyllable[],
  syllableSeparator = "\xAD"
) =>
  syls.reduce((result, syl) => {
    return result + syl.toString(syllableSeparator);
  }, "");
